import axios from 'axios';

export default axios.create({
    baseURL: 'https://lemonassist.herokuapp.com/'
});